import { Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import Home from './pages/Home';
import Register from './pages/Register';
import Lookup from './pages/Lookup';
import RegistryCard from './pages/RegistryCard';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import AdminEdit from './pages/AdminEdit';
import PrivateRoute from './components/PrivateRoute';
import { RegistryProvider } from './context/RegistryContext';
import { AuthProvider } from './context/AuthContext';
import ConfirmationPage from './pages/ConfirmationPage';
import NotFound from './pages/NotFound';

function App() {
  return (
    <AuthProvider>
      <RegistryProvider>
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<Home />} />
            <Route path="register" element={<Register />} />
            <Route path="lookup" element={<Lookup />} />
            <Route path="registry/:id" element={<RegistryCard />} />
            <Route path="confirmation/:id" element={<ConfirmationPage />} />
            <Route path="admin/login" element={<AdminLogin />} />
            
            {/* Protected Routes */}
            <Route path="admin" element={<PrivateRoute />}>
              <Route path="dashboard" element={<AdminDashboard />} />
              <Route path="edit/:id" element={<AdminEdit />} />
            </Route>
            
            {/* 404 Route */}
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
      </RegistryProvider>
    </AuthProvider>
  );
}

export default App;